import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MathLevelList = _resolveComponent("MathLevelList")!
  const _component_MathLevelPlay = _resolveComponent("MathLevelPlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isNaN(_ctx.currentLevelId))
      ? (_openBlock(), _createBlock(_component_MathLevelList, {
          key: 0,
          onChangeLevel: _ctx.selectLevel
        }, null, 8, ["onChangeLevel"]))
      : (_openBlock(), _createBlock(_component_MathLevelPlay, {
          key: 1,
          level: _ctx.currentLevel,
          "is-mathsframe": _ctx.isMathsframe
        }, null, 8, ["level", "is-mathsframe"]))
  ]))
}